export default __webpack_public_path__ + "static/media/bell.9f4f029d.mp3";